/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { createSelector } from 'reselect';

export const getMfeCheckoutState = (state) => state?.mfeCheckout;
export const getRecaptchaV2Token = (state) => state?.mfeCheckout.app.recaptchaV2Token || null;

export const getIsAuth0TriggerCalled = (state) => state?.mfeCheckout?.app?.abTest?.isAuth0TriggerCalled || false;

export const getAllCheckoutSaleForceABTest = (state) => state?.mfeCheckout?.app?.abTest;

export const getShortenedShippingSaleForceABTest = (state) => state?.mfeCheckout?.app?.abTest?.shortenedShipping;
export const getMiddlePlaceOrderSaleForceABTest = (state) => state?.mfeCheckout?.app?.abTest?.middlePlaceOrder;

export const getOnePageCheckoutSaleForceABTest = (state) => state?.mfeCheckout?.app?.abTest?.onePageCheckout;

export const getDeliveryDateSelectionsSalesForceABTestData = (state) => state?.mfeCheckout.app?.abTest?.deliveryDateSelections || {};

export const getAppContextAddressSource = (state) => state.ui?.appContext?.userSubmittedAddress?.addressSource || null;

export const getOfferGatewayData = (state) => state.ui?.dialog?.offerGateway;

export const getRememberMeSaleForceABTest = (state) => state?.mfeCheckout?.app?.abTest?.rememberMe;

export const getCalendarMessageSaleForceABTest = (state) => state?.mfeCheckout.app?.abTest?.calendarMessage;

export const getModalQasRadioBtnSFABTest = (state) => state?.mfeCheckout.app?.abTest?.modalQasRadioButtons;

export const getCheckUnverifiedAddressesSFABTest = (state) => state?.mfeCheckout.app?.abTest?.unverifiedAddresses;

export const getLongerPassportMessageSFABTest = (state) => state?.mfeCheckout.app?.abTest?.longerPassportMessage;

export const getEnterpriseCalendarSFABTest = (state) => state?.mfeCheckout.app?.abTest?.enterpriseCalendar;

export const getNewProductCardLayoutEnabled = (state) => state?.mfeCheckout?.app?.abTest?.newProductCardEnabled || {};
export const getCardisleGridViewSaleForceABTest = (state) => state?.mfeCheckout?.app?.abTest?.cardisleGridView;
export const getOrderSummaryRemappingSFABTest = (state) => state?.mfeCheckout.app?.abTest?.orderSummaryRemapping;

export const getIsCheckoutReducerLoaded = (state) => {
    const mfeCheckout = getMfeCheckoutState(state);

    if (mfeCheckout) {
        return true;
    }

    return false;
};

export const getFeatureFlags = (state) => {
    const mfeCheckout = getMfeCheckoutState(state);
    return mfeCheckout?.app?.featureFlags || {};
};

export const getFeatureFlag = (selector) => createSelector(
    [getFeatureFlags],
    (featureFlags) => {
        if (Array.isArray(selector)) {
            let result = featureFlags;
            // eslint-disable-next-line consistent-return
            selector.forEach((propertyName) => {
                // eslint-disable-next-line no-prototype-builtins
                if (!result?.hasOwnProperty || !result.hasOwnProperty(propertyName)) {
                    return false;
                }
                result = result[propertyName];
            });

            return result;
        }

        if (featureFlags) {
            return featureFlags?.[selector] ?? false;
        }

        return false;
    },
);

export const getBrandConfig = (state) => {
    const mfeCheckout = getMfeCheckoutState(state);

    return mfeCheckout?.app?.config || {};
};

export const getCheckoutAppConfigLoaded = (state) => {
    const flags = getFeatureFlags(state);
    const config = getBrandConfig(state);

    if (Object.keys(flags).length > 0 && Object.keys(config).length > 0) {
        return true;
    }

    return false;
};

export const getRelationshipListByIds = (state) => state?.mfeCheckout?.app?.relationshipList?.byId || {};
export const getRelationshipListByValues = (state) => state?.mfeCheckout?.app?.relationshipList?.byValue || {};

export const getRecipientTypeSelected = (state) => state?.mfeCheckout?.app?.recipientType || '';

export const getRelationshipListById = createSelector(
    [getRelationshipListByIds],
    (relationshipListById) => {
        if (relationshipListById) {
            return relationshipListById;
        }
        return {};
    },
);

export const getRelationshipListByValue = createSelector(
    [getRelationshipListByValues],
    (relationshipListByValues) => {
        if (relationshipListByValues) {
            return relationshipListByValues;
        }
        return {};
    },
);

export const getDeliveryDateSelectionsSalesForceABData = (state) => state?.mfeCheckout?.app?.abTest?.deliveryDateSelections;
export const getDeliveryDateSelectionsSalesForceABTest = (state) => {
    const featureFlags = getFeatureFlags(state);

    // the flag can force show the new design without the saleforce be running.
    if (featureFlags['is-delivery-date-selections-enabled'] === 'newflow') {
        return 'Default';
    }

    // We look for the ab test campaign on sale force
    if (
        featureFlags['is-delivery-date-selections-enabled'] === 'salesforce'
        && state?.mfeCheckout?.app?.abTest?.deliveryDateSelections?.campaign?.campaignResponses?.[0]?.userGroup
    ) {
        return state.mfeCheckout.app.abTest.deliveryDateSelections.campaign.campaignResponses[0].userGroup;
    }

    return 'Control';
};
